import OlMap from '@m1/ol-map';
import useMountEffect from '@restart/hooks/useMountEffect';
import { fromLonLat } from 'ol/proj';
import { useRef } from 'react';
import { useStore } from 'react-redux';

import EventEmitter from '@/libs/EventEmitter';
import { NotifierService as notifier } from '@/libs/Notifier';

// 알림 간격
const NOTIFICATION_THROTTLE_MS = 5000; // 5초

const useZoneObserver = () => {
  const store = useStore();
  const lastNotificationTime = useRef(new Map());

  useMountEffect(() => {
    const token = EventEmitter.subscribe('position/update', ({ robotId, position }) => {
      // 알림 간격 시간 내 중복 알림인 경우 조기 반환
      const now = Date.now();
      const lastTime = lastNotificationTime.current.get(robotId) || 0;
      if (now - lastTime < NOTIFICATION_THROTTLE_MS) return;

      // 구역 침범 감지되지 않은 경우 조기 반환
      const isBreached = checkZoneBreach(position);
      if (!isBreached) return;

      const robot = store.getState().robots.find(({ id }) => id === robotId);

      notifier.error(`${robot.name} breaches restricted zone.`);
      lastNotificationTime.current.set(robotId, now);
    });

    return () => {
      EventEmitter.unsubscribe(token);
    };
  });

  // 로봇의 구역 침범 여부 확인
  const checkZoneBreach = (position) => {
    const map = OlMap.getMap();
    const layers = map.getLayers().getArray();
    const zoneLayers = layers.filter((layer) => layer.get('isZone'));

    const { lat, lng } = position;
    const coordinate = fromLonLat([lng, lat]);

    return zoneLayers.some((layer) => {
      const features = layer.getSource().getFeatures();

      return features.some((feature) => feature.getGeometry().intersectsCoordinate(coordinate));
    });
  };
};

export default useZoneObserver;
